import { useLocales } from '@shared/locales'
import { Space } from 'antd'

export const NotFound = () => {
  const { t } = useLocales()

  return (
    <Space direction="vertical" className="error-page">
      <h1 className="error-page__title">{t('error.404')}</h1>
      <h2 className="error-page__description">{t('error.page_not_found')}</h2>
    </Space>
  )
}
